import styled from 'styled-components';
import React from "react";

const Label = styled(({grow, ...props}) => (
    React.createElement('label', props)
))`
    display: block;
    box-sizing: border-box;
    text-align: left;
    font-weight: bold;
    font-size: 14px;
    color: currentColor;
    font-family: 'BentonSans Book', sans-serif;
    margin-bottom: 15px;
    flex-grow: ${({grow}) => grow ? 1 : 0};
`;

export default Label;
